import React, { useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls } from '@react-three/drei';
import { Mur3DGroup } from './MurVisualisation3D';

export default function PieceVisualisation3D({ murs, resultat, onSelectMur, murSelectionneeId }) {

    // Calcul du centre de la pièce pour la caméra
    const center = useMemo(() => {
        if (!murs || murs.length === 0) return [0, 0, 0];

        // Si c'est une pièce rectangulaire (4 murs), on peut deviner le centre
        // Sinon on prend la moyenne des positions
        // Pour une pièce rectangulaire standard générée par le store:
        // Mur 1 (0,0,0) -> Mur 3 (W, 0, L). Centre approx: W/2, H/2, L/2

        // On va simplement prendre le mur 1 comme référence + un offset
        const murRef = murs[0];
        return [murRef.largeur / 2, murRef.hauteur / 2, murRef.largeur / 2];
    }, [murs]);

    return (
        <div style={{ width: '100%', height: '600px', backgroundColor: '#f0f2f5', borderRadius: '8px', overflow: 'hidden', position: 'relative' }}>
            <div style={{ position: 'absolute', top: 10, left: 10, zIndex: 10, background: 'rgba(255,255,255,0.8)', padding: '5px', borderRadius: '4px' }}>
                <small>Double-clic sur un mur pour le sélectionner</small>
            </div>

            <Canvas
                camera={{ position: [center[0] * 2, center[1] * 3, center[2] * 4], fov: 60 }}
                shadows
            >
                <color attach="background" args={['#212529']} /> {/* Fond plus foncé pour global */}

                {/* Lumières */}
                <ambientLight intensity={0.5} />
                <pointLight position={[center[0], 300, center[2]]} intensity={0.8} />
                <directionalLight position={[100, 200, 100]} intensity={0.6} castShadow />

                {/* Contrôles */}
                <OrbitControls target={[center[0], center[1], center[2]]} />

                {/* Grille de sol */}
                <gridHelper args={[2000, 50, '#495057', '#343a40']} rotation={[0, 0, 0]} position={[center[0], -5, center[2]]} />

                {/* Affichage de tous les murs */}
                {murs.map((mur) => {
                    // Filtrer le résultat pour ce mur
                    const plaquesMur = resultat?.plaques?.filter(p => p.murId === mur.id) || [];
                    const ossatureMur = resultat?.murDetails?.find(m => m.murId === mur.id)?.ossature;
                    const isSelected = mur.id === murSelectionneeId;

                    return (
                        <Mur3DGroup
                            key={mur.id}
                            mur={mur}
                            ossature={ossatureMur}
                            plaques={plaquesMur}
                            isSelected={isSelected}
                            onClick={onSelectMur}
                        />
                    );
                })}

                {/* Sol de la pièce (optionnel, basé sur les murs extrêmes ?) */}
                {/* On laisse la gridHelper pour l'instant */}

            </Canvas>
        </div>
    );
}
